global.conmed = global.conmed || {};

conmed.sitesearch = function ($) {
    'use strict';
    var that = {

    };

    that.init = function () {
        $('#searchBtn').on('click', function (e) {

            var searchStr = $("#searchBox").val();            
            window.location.href = window.location.pathname + "?query=" + searchStr;
        });

        $(".showmore").on("click", function (e) {
            e.preventDefault();
            $(".results").toggleClass("blur");

            if ($(this).text() == "Show More") {
                $(this).text("Show Less");
            }
            else{
                $(this).text("Show More");
            }

        });

        $('#searchBox').on('keyup',function (e) {
            if (e.which == 13) { // enter key
                $('#searchBtn').click();
            }
        });

        $('#headerStartSearch').on('click', function (e) {
            $('.search-div').show(500);
            $('.search-div').addClass('slide');
        });

        $('#headerSearchBtn').on('click', function () {
            var headerText = $('#headerSearchText').val();
            var currentLang = $('#currentLangHeader').val();
            headerSearch(headerText, currentLang);
            return false;
        })

        $('#headerSearchForm').on('submit', function () {
            var headerText = $('#headerSearchText').val();
            var currentLang = $('#currentLangHeader').val();
            headerSearch(headerText, currentLang);
            return false;
        })

        function headerSearch(input, lang) {
            window.location.href = "/" + lang + "/search-page" + "?query=" + input;
        }

        $('#categorySearchBtn').on('click', function (e) {
            var categoryOne = $('#categoryOne').find(":selected").val();
            var categoryTwo = $('#categoryTwo').find(":selected").val();
            var categoryThree = $('#categoryThree').find(":selected").val();
            var currentLang = $('#currentLangHeader').val();

            window.location.href = "/" + currentLang + "/search-page" + "?tags=" + categoryOne + "|" + categoryTwo + "|" + categoryThree;
        });

        $('.facet-item').on('click', function (e) {
            var tag = $(this).attr('id');
            var query = $('#searchQuery').val();
            var tags = $('#currentTags').val();
            var templates = $('#currentTemplates').val();

            if (tags.indexOf(tag) == -1) {
                if (tags.length > 0) {
                    tags += '|' + tag;
                }
                else {
                    tags += tag;
                }
            }

            window.location.href = window.location.pathname + "?query=" + query + "&tags=" + tags + "&templates=" + templates;
        })

        $('.template-item').on('click', function (e) {
            var template = $(this).attr('id');
            var query = $('#searchQuery').val();
            var tags = $('#currentTags').val();
            var templates = $('#currentTemplates').val();

            if (templates.indexOf(template) == -1) {
                if (templates.length > 0) {
                    templates += '|' + template;
                }
                else {
                    templates += template;
                }
            }

            window.location.href = window.location.pathname + "?query=" + query + "&tags=" + tags + "&templates=" + templates;
        })

        $('.selected-facet-item').on('click', function (e) {
            var tag = $(this).data('tag');
            var query = $('#searchQuery').val();
            var templates = $('#currentTemplates').val();
            var tags = $('#currentTags').val();

            if (tags.indexOf(tag) >= 0) {
                tags = tags.replace("|" + tag, "");
                tags = tags.replace(tag, "");
            }

            window.location.href = window.location.pathname + "?query=" + query + "&tags=" + tags + "&templates=" + templates;
        })

        $('.selected-template-item').on('click', function (e) {
            var template = $(this).data('tag');
            var query = $('#searchQuery').val();
            var templates = $('#currentTemplates').val();
            var tags = $('#currentTags').val();

            if (templates.indexOf(template) >= 0) {
                templates = templates.replace("|" + template, "");
                templates = templates.replace(template, "");
            }

            window.location.href = window.location.pathname + "?query=" + query + "&tags=" + tags + "&templates=" + templates;
        })        
    };

    return that;
}(jQuery);